module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/01-03.1864bbe3.mp3";